import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Store/actions";
import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    DialogActions,
    FormControl,
    TextField,
    InputLabel,
    Select,
    MenuItem,
    Typography
} from "@mui/material/";
import { strings } from "../../common/i18n";
export default ({
    open,
    onClose,
    row,
    setLoading,
    currentStatus,
    fetchAudits
}) => {
    const [archiveData, setArchiveData] = useState({});
    const { auth, typesList } = useSelector((state) => state);
    const { archiveReasons, auditStatus } = typesList;

    /** Get close audit status id  */
    const auditReason = useMemo(() => {
        return auditStatus.data.find((item) => item.name === "closed");
    }, [auditStatus]);

    const archivetypes = archiveReasons ? archiveReasons.data : {};
    const dispatch = useDispatch();

    const handleSubmission = async () => {
        setLoading(true);
        const now = new Date().toISOString();

        const postReason = {
            archivedBy: auth.account.id,
            audit: Array.isArray(row) ? row : row.id,
            created_date: now,
            ...archiveData
        };
        onClose();

        await dispatch(actions.auditArchive.create.postRequest(postReason));
        await fetchAudits();
        dispatch(
            actions.toast.create.success(strings("messages.auditArchived"))
        );
        setLoading(false);
    };

    const { note, reason } = archiveData;
    return (
        row && (
            <>
                <Dialog open={open} onClose={onClose}>
                    <FormControl>
                        <DialogTitle>{strings("archiveAudit")}</DialogTitle>
                        <Divider />

                        <DialogContent spacing={3}>
                            <DialogContentText>
                                {strings("messages.archiveAuditReason")}
                                <Typography color="primary" component="span">
                                    {Array.isArray(row)
                                        ? ` ${row.length} ${strings("audits")}`
                                        : ` ${row.name}`}
                                </Typography>
                            </DialogContentText>

                            {archivetypes.length > 0 ? (
                                <FormControl
                                    fullWidth
                                    margin="normal"
                                    variant="standard"
                                >
                                    <InputLabel>{strings("reason")}</InputLabel>
                                    <Select
                                        label="Reason Type"
                                        name="reason"
                                        variant="standard"
                                        onChange={(e) => {
                                            setArchiveData((prevState) => ({
                                                ...prevState,
                                                reason: e.target.value
                                            }));
                                        }}
                                        value={reason || ""}
                                    >
                                        {archivetypes.map((item) => (
                                            <MenuItem
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        multiline
                                        name="archieveNote"
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            setArchiveData((prevState) => ({
                                                ...prevState,
                                                note: value
                                            }));
                                        }}
                                        placeholder={strings(
                                            "messages.enterNote"
                                        )}
                                        minRows={4}
                                        value={note}
                                        variant="outlined"
                                    />
                                </FormControl>
                            ) : null}
                        </DialogContent>
                        <Divider />
                        <DialogActions>
                            <Button
                                onClick={handleSubmission}
                                variant="outlined"
                                color="primary"
                                disabled={
                                    note !== undefined && reason !== undefined
                                        ? false
                                        : true
                                }
                            >
                                {strings("submit")}
                            </Button>
                            <Button
                                onClick={onClose}
                                variant="outlined"
                                color="primary"
                            >
                                {strings("cancel")}
                            </Button>
                        </DialogActions>
                    </FormControl>
                </Dialog>
            </>
        )
    );
};
